// Screen `roles` — design/screens/SettingsAccess.dc.html — owner: S10.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RolesPage } from '../../../features/access/RolesPage';

export const Route = createFileRoute('/_settings/settings/roles')({
  validateSearch: z.object({
    role: z.string().max(64).optional(),
    viewAs: z.string().max(64).optional(),
    /** An object's row of the access matrix to show (the object builder's Permissions tab links here). */
    object: z.string().max(63).optional(),
  }),
  component: RolesRoute,
});

function RolesRoute() {
  const { role, viewAs, object } = Route.useSearch();
  return <RolesPage roleId={role || undefined} viewAs={viewAs || undefined} object={object || undefined} />;
}
